<template>
  <b-container fluid>
    <b-row v-if="container === 'professionals'">
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-address-book"></i>
              {{
                $t(
                            "public.views.Pages.Professional.Organization.Professionals.title"
                )
              }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button v-if="
              checkPermissionProfessional('ORGANIZATION_PROFESSIONALS', [
                'CREATE',
              ])
            " ref="btnShowNewContact" style="right" variant="success" @click="showModal">{{
  $t(
              "public.views.Pages.Professional.Organization.Professionals.btnInvitation"
  )
}}
            </b-button>
          </template>
          <template v-if="
            checkPermissionProfessional('ORGANIZATION_PROFESSIONALS', [
              'LIST',
            ])
          " v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getProfessionalsExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-card-title>
                <v-text-field v-model="search" hide-details single-line @blur="getAllProfessionals">
                  <template slot="label">
                    <div class="search-datatable">
                      <i class="fas fa-search fa-fw"></i>
                      {{
                        $t(
                                            "public.views.Pages.Professional.Organization.Professionals.search"
                        )
                      }}
                    </div>
                  </template>
                </v-text-field>
                <b-button class="mt-3 ml-2" variant="primary" @click="getAllProfessionals">
                  {{
                    $t(
                                    "public.views.Pages.Professional.Organization.Professionals.search"
                    )
                  }}
                </b-button>
              </v-card-title>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="professionals" :options.sync="pagination" :search="search"
                :server-items-length="total" item-key="id">
                <template v-slot:item.avatar="{ item }">
                  <b-avatar class="mr-2" v-bind:src="
                    item.avatarUrl
                      ? item.avatarUrl +
                      '/' +
                      getAuthentication()
                      : ''
                  "></b-avatar>
                </template>
                <template v-slot:item.activate="{ item }">
                  <span v-if="item.activate" class="badge badge-success">{{
                    $t("generic.yes")
                  }}</span>
                  <span v-else class="badge badge-danger">{{
                    $t("generic.no")
                  }}</span>
                </template>
                <template v-slot:item.id="{ item }">
                  <div class="div-table-data">
                    <button v-if="
                      checkPermissionProfessional(
                        'ORGANIZATION_PROFESSIONALS',
                        ['EDIT']
                      )
                    " :id="'btnSee' + item.id" class="item" v-on:click="getProfessional(item.id)">
                      <i class="ri-eye-line"></i>
                    </button>
                    <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                                              "public.views.Pages.Professional.Organization.Professionals.btnSee"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button v-if="
                      !item.activate &&
                      checkPermissionProfessional(
                        'ORGANIZATION_PROFESSIONALS',
                        ['EDIT']
                      )
                    " :id="'btnSend' + item.id" class="item" v-on:click="sendInvitationProfessional(item.id)">
                      <i class="ri-mail-send-line"></i>
                    </button>
                    <b-popover v-if="
                      !item.activate &&
                      checkPermissionProfessional(
                        'ORGANIZATION_PROFESSIONALS',
                        ['EDIT']
                      )
                    " :target="'btnSend' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                                              "public.views.Pages.Professional.Organization.Professionals.btnSend"
                        )
                      }}
                      </template>
                    </b-popover>
                    <button v-if="
                      item.role !== 'ADMIN' &&
                      checkPermissionProfessional(
                        'ORGANIZATION_PROFESSIONALS',
                        ['DELETE']
                      )
                    " :id="'btnDelete' + item.id" class="item" v-on:click="deleteProfessional(item.id)">
                      <i class="ri-delete-bin-line"></i>
                    </button>
                    <b-popover v-if="
                      checkPermissionProfessional(
                        'ORGANIZATION_PROFESSIONALS',
                        ['DELETE']
                      )
                    " :target="'btnDelete' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                                              "public.views.Pages.Professional.Organization.Professionals.btnDelete"
                        )
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-modal id="modal-new-contact" centered size="lg" @ok="saveFormStep1">
        <template #modal-title>{{
          $t(
                  "public.views.Pages.Professional.Organization.Professionals.modalCreate.title"
          )
        }}
        </template>
        <template #modal-ok>{{
          $t(
                  "public.views.Pages.Professional.Organization.Professionals.modalCreate.invitation"
          )
        }}
        </template>
        <template #modal-cancel>{{
          $t(
                  "public.views.Pages.Professional.Organization.Professionals.modalCreate.cancel"
          )
        }}
        </template>
        <form action="#">
          <b-form-group label-for="email">
            <template slot="label">{{
              $t(
                          "public.views.Pages.Professional.Organization.Professionals.modalCreate.email"
              )
            }}* :
            </template>
            <b-form-input id="email" v-model="email" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormEmailErrors,
              'is-invalid': isFormEmailErrors,
            }" @blur="checkEmail(email, emailInUse)"></b-form-input>
            <ul v-if="isFormEmailErrors">
              <li v-for="(error, index) in validatorStep1.getErrors('email')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>

          <b-form-group label-for="emailConfirm">
            <template slot="label">{{
              $t(
                          "public.views.Pages.Professional.Organization.Professionals.modalCreate.emailConfirm"
              )
            }}* :
            </template>
            <b-form-input id="emailConfirm" v-model="emailConfirm" :disabled="disabled" type="text" v-bind:class="{
              'text-danger': isFormEmailConfirmErrors,
              'is-invalid': isFormEmailConfirmErrors,
            }" @blur="checkEmailConfirm(email, emailConfirm)"></b-form-input>
            <ul v-if="isFormEmailConfirmErrors">
              <li v-for="(error, index) in validatorStep1.getErrors(
                'emailConfirm'
              )" v-bind:key="index" class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>

          <b-form-group label-for="role">
            <template slot="label">{{
              $t(
                          "public.views.Pages.Professional.Organization.Professionals.modalCreate.role"
              )
            }}* :
            </template>
            <b-select id="role" v-model="role" :disabled="disabled" :options="roleSelect" class="form-control" multiple
              v-bind:class="{
                'text-danger': isFormRoleErrors,
                'is-invalid': isFormRoleErrors,
              }" @blur="checkRole(role)">
            </b-select>
            <ul v-if="isFormRoleErrors">
              <li v-for="(error, index) in validatorStep1.getErrors('role')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </form>
      </b-modal>
    </b-row>

    <b-row v-if="container === 'settings'">
      <b-col lg="12">
        <div class="iq-card">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="far fa-address-book"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.title"
                  )
                }}
                - {{ name }} {{ lastname }} ({{ document }})
              </h4>
            </div>
          </div>
        </div>
        <tab-nav :pills="true" class="iq-edit-profile d-flex pill-theme">
          <tab-nav-items :active="true" class="col-md-2 p-0" href="#schedule-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.schedule.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-2 p-0" href="#season-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="fas fa-calendar-alt"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.season.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-2 p-0" href="#personal-information-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="fas fa-user-circle"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.personalInformation.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-2 p-0" href="#visit-type-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-video-chat-line"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.visitType.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-2 p-0" href="#role-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="fas fa-lock"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.role.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-2 p-0" href="#ipros-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                {{
                  $t(
                                "public.views.Pages.Professional.Organization.Professionals.tab.ipros.tab"
                  )
                }}
              </h4>
            </template>
          </tab-nav-items>
        </tab-nav>
      </b-col>
      <b-col lg="12">
        <div class="iq-edit-list-data">
          <tab-content id="pills-tabContent-2">
            <tab-content-item id="schedule-tab" :active="true">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="ri-calendar-event-fill"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.schedule.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button class="mr-2" style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                </template>
                <template v-slot:body>
                  <!--   <b-row>
                    <b-col cols="12">
                      <b-form-group label-for="professionals">
                        <template slot="label"
                          >{{
                            $t(
                              "public.views.Pages.Professional.Dashboard.professional"
                            )
                          }}:
                        </template>

                        <multiselect
                          v-model="professionalsFilter"
                          :options="professionalSelect"
                          :multiple="false"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          :preselect-first="true"
                          v-bind:placeholder="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.placeholder2'
                            )
                          "
                          v-bind:selectGroupLabel="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.selectGroupLabel'
                            )
                          "
                          v-bind:selectLabel="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.selectLabel'
                            )
                          "
                          v-bind:selectedLabel="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.selectedLabel'
                            )
                          "
                          v-bind:deselectLabel="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.deselectLabel'
                            )
                          "
                          v-bind:deselectGroupLabel="
                            $t(
                              'public.views.Pages.Professional.Dashboard.multiselect.deselectGroupLabel'
                            )
                          "
                          label="text"
                          track-by="value"
                          @input="changeProfessionalsFilter"
                        >
                          <template slot="option" slot-scope="props">
                            <b-list-group-item
                              class="d-flex align-items-center"
                            >
                              <b-avatar
                                v-bind:src="props.option.avatar"
                                class="mr-3"
                              ></b-avatar>
                              <span class="mr-auto title-typography-color">{{
                                props.option.text
                              }}</span>
                            </b-list-group-item>
                          </template>
                          <template
                            slot="singleLabel"
                            slot-scope="props"
                            v-if="props.option.text"
                            ><span class="option__desc"
                              ><span class="option__title">
                                <b-avatar
                                  v-bind:src="props.option.avatar"
                                  class="mr-3"
                                ></b-avatar
                                ><span class="mr-auto title-typography-color">{{
                                  props.option.text
                                }}</span>
                              </span></span
                            ></template
                          >
                          <template
                            slot="selection"
                            slot-scope="{ values, isOpen }"
                            ><span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                              >{{ values.length }}
                              {{
                                $t(
                                  "public.views.Pages.Professional.Dashboard.selectedProfessionals"
                                )
                              }}</span
                            ></template
                          >
                        </multiselect>
                      </b-form-group>
                    </b-col>
                  </b-row>-->
                  <Schedule ref="schedule" :dashboard="false" :idProfessional="id"
                    :professionalsSchedule="professionalsSchedule" :typeSchedule="typeSchedule"
                    :visitTypeSchedule="visitTypeSchedule"></Schedule>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="season-tab" :active="false">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="fas fa-calendar-alt"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.season.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                </template>
                <template v-slot:body>
                  <Workschedule :idProfessional="id"></Workschedule>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="personal-information-tab" :active="false">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="fas fa-user-circle"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.personalInformation.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button class="mr-2" style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                  <b-button v-if="
                    checkPermissionProfessional(
                      'ORGANIZATION_PROFESSIONALS',
                      ['EDIT']
                    )
                  " style="right" variant="success" @click="savePersonalInformation">{{
  $t(
                    "public.views.Pages.Professional.Organization.Professionals.tab.personalInformation.btnSave"
  )
}}
                  </b-button>
                </template>
                <template v-slot:body>
                  <AccountProfessional ref="personalInformation" :header="false" :oldPassword="false"
                    :professionalId="id">
                  </AccountProfessional>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="visit-type-tab" :active="false">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="ri-video-chat-line"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.visitType.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                </template>
                <template v-slot:body>
                  <VisitType :organizationId="organizationId" :professionalId="id" :type="'PROFESSIONALS'"
                    :update="false" :visitTypes="visitTypes"></VisitType>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="role-tab" :active="false">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="fas fa-lock"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.role.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                </template>
                <template v-slot:body>
                  <RoleProfessional :professionalId="id"></RoleProfessional>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="ipros-tab" :active="false">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title title-typography-color">
                    <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                    {{
                      $t(
                                        "public.views.Pages.Professional.Organization.Professionals.tab.ipros.title"
                      )
                    }}
                  </h4>
                </template>
                <template v-slot:headerAction>
                  <b-button class="mr-2" style="right" variant="primary" @click="backProfessionals">{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Professionals.btnBack"
                    )
                  }}
                  </b-button>
                  <b-button v-if="
                    checkPermissionProfessional(
                      'ORGANIZATION_PROFESSIONALS',
                      ['EDIT']
                    )
                  " style="right" variant="success" @click="saveIpros">{{
  $t(
                    "public.views.Pages.Professional.Organization.Professionals.tab.personalInformation.btnSave"
  )
}}
                  </b-button>
                </template>
                <template v-slot:body>
                  <IprosFrom ref="ipros" :professionalId="id"></IprosFrom>
                </template>
              </iq-card>
            </tab-content-item>
          </tab-content>
        </div>
      </b-col>
    </b-row>
    <b-modal id="modal-delete" centered @ok="saveFormStep2">
      <template #modal-title>
        {{
          $t(
                "public.views.Pages.Professional.Organization.Professionals.modalDelete.title"
          )
        }}
      </template>
      <template #modal-ok>{{
        $t(
              "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnDelete"
        )
      }}
      </template>
      <template #modal-cancel>{{
        $t(
              "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnClose"
        )
      }}
      </template>
      <p>
        {{
          $t(
                "public.views.Pages.Professional.Organization.Professionals.modalDelete.body"
          )
        }}
      </p>
      <b-form-group label-for="professional">
        <template slot="label">{{
          $t(
                  "public.views.Pages.Professional.Organization.Professionals.modalDelete.professional"
          )
        }}: *
        </template>
        <multiselect v-model="professionalDelete" :clear-on-select="false" :close-on-select="false" :multiple="false"
          :options="professionalSelect" :preselect-first="true" :preserve-search="true" label="text" track-by="value"
          v-bind:class="{
            'text-danger': isFormProfessionalDeleteErrors,
            'is-invalid': isFormProfessionalDeleteErrors,
          }" v-bind:deselectGroupLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.deselectGroupLabel'
  )
" v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Dashboard.multiselect.selectedLabel'
  )
" @blur="checkProfessionalDelete(professionalDelete)">
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
          <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                class="option__title">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                  class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
              </span></span></template>
          <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
              class="multiselect__single">{{ values.length }}
              {{
                $t(
                            "public.views.Pages.Professional.Dashboard.selectedProfessionals"
                )
              }}</span></template>
        </multiselect>
        <ul v-if="isFormProfessionalDeleteErrors">
          <li v-for="(error, index) in validatorStep2.getErrors(
            'professionalDelete'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>

    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../../../router/index";
import { xray } from "../../../../config/pluginInit";

import TimeZone from "../../../../services/timeZone";
import Language from "../../../../json/Language";

import validator from "vue-m-validator";
import { saveAs } from "file-saver";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import IprosFrom from "../../../../components/ipros/IprosForm";
import Schedule from "../../../../components/schedule/Schedule";
import AccountProfessional from "../../../../components/account/Professional";
import VisitType from "../../../../components/organization/VisitType";
import RoleProfessional from "../../../../components/role/RoleProfessional";
import Workschedule from "../../../../components/workschedule/Workschedule";

import professionalService from "../../../../services/professional";
import roleService from "../../../../services/role";
import organizationService from "../../../../services/organization";
import utilsService from "../../../../services/utils";

export default {
  name: "Professionals",
  components: {
    VuePhoneNumberInput,
    "vue-dropzone": vue2Dropzone,
    Schedule,
    AccountProfessional,
    VisitType,
    RoleProfessional,
    IprosFrom,
    Workschedule,
    Multiselect,
  },
  mounted() {
    xray.index();
    this.getAllProfessionals();
    //Tab visit type
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PROFESSIONALS", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllProfessionals();
        }
        this.start = true;
      },
    },
  },
  computed: {
    isFormEmailErrors() {
      if (!this.disabled) {
        const RULE_2_REGEXP = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        );
        let errors = this.validatorStep1.getErrors("email");
        return errors && errors.length > 0;
      }
    },
    isFormEmailConfirmErrors() {
      if (!this.disabled) {
        const RULE_2_REGEXP = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        );
        if (RULE_2_REGEXP.test(this.emailConfirm)) {
          this.checkEmailConfirm(this.email, this.emailConfirm);
        }
        let errors = this.validatorStep1.getErrors("emailConfirm");
        return errors && errors.length > 0;
      }
    },
    isFormRoleErrors() {
      let errors = this.validatorStep1.getErrors("role");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validatorStep1.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validatorStep1.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validatorStep1.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validatorStep1.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormLanguageErrors() {
      let errors = this.validatorStep1.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validatorStep1.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validatorStep1.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validatorStep1.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validatorStep1.getErrors("timeZone");
      return errors && errors.length > 0;
    },
    isFormProfessionalDeleteErrors() {
      let errors = this.validatorStep2.getErrors("professionalDelete");
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },

    changeProfessionalsFilter() {
      this.visitTypeSchedule = [];
      this.professionalsSchedule = [];
      this.visitTypeFilter = [];

      let self = this;
      if (
        this.professionalsFilter &&
        this.professionalsFilter.value &&
        this.professionalsFilter.text
      ) {
        let data = {
          idProfessional: this.professionalsFilter.value,
          titleProfessional: this.professionalsFilter.text,
          fileProfessional: this.professionalsFilter.file,
          avatarUrl: this.professionalsFilter.avatar
            ? this.professionalsFilter.avatar +
            "/" +
            localStorage.getItem("authorization")
            : "",
        };

        self.professionalsSchedule.push(data);
      }
    },
    getProfessionalsExcel() {
      let data = {
        name: this.search,
      };

      this.$awn.asyncBlock(
        organizationService.getAllProfessionalsExcel(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PROFESSIONALS_EXCEL", info: "" });
            saveAs(response.data, "professionals.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllProfessionalsExcel",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    saveFormStep2(evt) {
      evt.preventDefault();
      this.checkFormStep2();
      if (this.validatorStep2.errors.length === 0) {
        this.deteteProfessional();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.notification.descErrorForm"
          ),
          type: "error",
        });
      }
    },
    deteteProfessional() {
      let self = this;

      let data = {
        professional: this.professionalDelete.value,
      };
      this.$awn.asyncBlock(
        professionalService.delete(data, this.idDelete),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_PROFESSIONALS", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.descDeleteProf"
              ),
              type: "success",
            });
            self.getAllProfessionals();
            self.$bvModal.hide("modal-delete");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.delete",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data,
              idDelete: this.idDelete
            })
          });
        },
        " "
      );
    },
    checkFormStep2() {
      this.checkProfessionalDelete(this.professionalDelete);
    },
    checkProfessionalDelete(_professional) {
      const professional =
        _professional != null ? _professional.toString() : null;
      const RULE_1 = {
        expression: !professional || professional === "",
        name: "professionalDelete",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erProfessional"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    getAllSelectProfessionals(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAll(),
        (response) => {
          if (response) {
            let combo = [];
            response.data.forEach(function (item) {
              let name = "";

              if (item.name) {
                name = name + item.name + " ";
              }

              if (item.lastname) {
                name = name + item.lastname + " (";
              }
              if (item.document) {
                name = name + item.document + " - ";
              }
              if (item.email) {
                name = name + item.email + ")";
              }
              if (item.id !== id) {
                combo.push({
                  value: item.id,
                  text: name,
                });
              }
            });

            self.professionalSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        }
      );
    },
    deleteProfessional(id) {
      this.idDelete = id;
      this.getAllSelectProfessionals(id);
      this.$swal({
        text: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errorSwal.deleteProf"
        ),
        showCancelButton: true,
        confirmButtonText: "Borrar",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$bvModal.show("modal-delete");
        }
      });
    },
    //Select organization
    backProfessionals() {
      this.container = "professionals";
    },
    getProfessional(id) {
      let self = this;

      organizationService
        .getProfessional(id)
        .then((response) => {
          self.validatorStep1.errors = [];
          self.disabled = true;
          self.clearModal();
          if (response) {
            self.id = id;
            self.email = response.data.email;
            self.password = response.data.password;
            self.passwordConfirm = response.data.passwordConfirm;
            self.name = response.data.name;
            self.lastname = response.data.lastname;
            self.document = response.data.document;
            self.language = response.data.language;
            self.address = response.data.address;
            self.avatar = response.data.avatar;
            self.filename = response.data.filename;
            self.phone = response.data.phone;
            self.phoneVuePhoneNumberInput = response.data.phone;
            self.country = response.data.country;
            self.timeZone = response.data.timeZone;
          }
          self.container = "settings";
          self.getAllVisitTypes(self.id);
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getProfessional",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        });
    },
    createProfessional() {
      let self = this;
      let data = {
        id: id,
        email: self.email,
        password: self.password,
        passwordConfirm: self.passwordConfirm,
        name: self.name,
        lastname: self.lastname,
        document: self.document,
        language: self.language,
        address: self.address,
        avatar: self.avatar,
        filename: self.filename,
        phone: self.phone,
        country: self.country,
        timeZone: self.timeZone,
      };

      this.$awn.asyncBlock(
        organizationService.createProfessional(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PROFESSIONALS", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.descSaveProf"
              ),
              type: "success",
            });
            self.getAllProfessionals();
            self.$bvModal.hide("modal-new-contact");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.createProfessional",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    async getAllProfessionals() {
      let self = this;

      let data = {
        name: this.search,
      };

      this.$awn.asyncBlock(
        organizationService.getAllProfessionalsPerformance(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          if (response) {
            self.professionals = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllProfessionalsPerformance",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        }
      );
    },
    getCheckEmail(email) {
      let self = this;

      utilsService
        .checkEmail(email)
        .then((response) => {
          if (response) {
            self.emailInUse = response.data;
            self.checkEmail(this.email, response.data);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    inviteCreateProfessional() {
      let self = this;

      let obj = {
        email: this.email,
        emailConfirm: this.emailConfirm,
        roles: this.role,
      };

      this.$awn.asyncBlock(
        professionalService.invite(obj),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PROFESSIONALS", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.descSendInvitation"
              ),
              type: "success",
            });
            self.getAllProfessionals();
            self.$bvModal.hide("modal-new-contact");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.invite",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    sendInvitationProfessional(id) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.sendInvitationProfessional(id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_PROFESSIONALS", info: "" });
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Professionals.notification.descSendInvitation"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.sendInvitationProfessional",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    clearModal() {
      this.id = "";
      this.email = "";
      this.emailConfirm = "";
      this.role = [];
    },
    showModal() {
      this.loadRoleSelect();
      this.disabled = false;
      this.clearModal();
      this.validatorStep1.errors = [];
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkEmail(_email, checkEmail) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmail1"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmail2"
        ),
      };
      const RULE_3 = {
        expression: checkEmail,
        name: "email",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmail3"
        ),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkEmailConfirm(_email, _emailConfirm) {
      const EMAILORIGIN = _email.trim();
      const EMAIL = _emailConfirm.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "emailConfirm",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmailConfirm"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "emailConfirm",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmailConfirm2"
        ),
      };
      const RULE_3 = {
        expression: EMAIL !== EMAILORIGIN,
        name: "emailConfirm",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erEmailConfirm3"
        ),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      this.notFirst();
    },
    checkRole(_role) {
      const ROLE = _role;
      const RULE_1 = {
        expression: !ROLE || ROLE === "" || ROLE.length === 0,
        name: "role",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erRol"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erLastName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erDocument"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkLanguage(_language) {
      const LANGUAGE = _language.trim();
      const RULE_1 = {
        expression: !LANGUAGE || LANGUAGE === "",
        name: "language",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erLanguage"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erPhone"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erCountry"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erAddress"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Professionals.errors.erTimeZone"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkEmail(this.email, this.emailInUse);
      this.checkEmailConfirm(this.email, this.emailConfirm);
      this.checkRole(this.role);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.inviteCreateProfessional();
        this.$bvModal.hide("modal-new-contact");
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    vdropzoneSuccess(file, response) {
      this.avatar = response.uuid;
      this.filename = response.name;
      this.getFile(response.uuid);
    },
    getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../../../assets/images/user/woman_profile.jpg");
        });
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
    //Tabs
    // Tab schedule
    createEventSchedule() {
      this.$refs.schedule.openModal(null);
    },
    // Tab personal information
    saveIpros() {
      this.$refs.ipros.saveForm();
    },
    // Tab personal information
    savePersonalInformation() {
      this.$refs.personalInformation.saveForm();
    },
    // Tab visit type
    getAllVisitTypes(professionalId) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.getAllVisitTypesProfessional(
          self.organizationId,
          professionalId
        ),
        (response) => {
          if (response) {
            self.visitTypes = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllVisitTypesProfessional",
            module: "view-pages-professional-organization-professionals",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: self.organizationId,
              professionalId: professionalId
            })
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      start: false,
      //Filter
      professionalsSchedule: [],
      professionalsFilterSelect: [],

      visitTypeSchedule: [],
      visitTypeFilterSelect: [],

      typeSchedule: "PROFESSIONAL",

      //Select Filter
      professionalsFilter: [],
      visitTypeFilter: [],

      total: 0,
      pagination: {},
      organizationId: localStorage.getItem("organizationId"),
      id: "",
      name: "",
      isFirstRun: true,
      emailInUse: false,
      email: "",
      emailConfirm: "",
      role: [],
      password: "",
      passwordConfirm: "",
      name: "",
      lastname: "",
      document: "",
      language: "",
      address: "",
      phoneVuePhoneNumberInput: "",
      phone: "",
      country: "",
      timeZone: "",
      avatar: "",
      filename: "",
      disabled: false,
      //Load select
      timeZoneSelect: TimeZone,
      languageSelect: Language,
      roleSelect: [],
      state: "disabled",
      validatorStep1: validator,
      validatorStep2: validator,
      password: "",
      passwordConfirm: "",
      //Avatar
      file: "",
      defaultAvatar: true,
      search: "",
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/avatar/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      //Container
      container: "professionals",
      //Translations phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },

      headers: [
        {
          text: "",
          value: "avatar",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.headers.lastname"
          ),
          value: "lastname",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.headers.email"
          ),
          value: "email",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Professionals.headers.active"
          ),
          value: "activate",
        },
        { text: "", value: "id" },
      ],
      professionals: [],
      professionalSelect: [],
      //Select
      async loadRoleSelect() {
        let self = this;

        this.$awn.asyncBlock(
          roleService.getAllWithoutPagination(),
          (response) => {
            if (response) {
              let combo = [];
              response.data.content.forEach(function (item) {
                combo.push({
                  value: item.id,
                  text: item.name !== null ? item.name : "",
                });
              });
              self.roleSelect = combo;

              this.$bvModal.show("modal-new-contact");
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "roleService.getAllWithoutPagination",
              module: "view-pages-professional-organization-professionals",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: null
            });
          },
          " "
        );
      },
      // Tabs
      // Schedule
      //  Visit type
      visitTypes: [],

      //Modal deleteProfessional
      idDelete: "",
      professionalDelete: "",
    };
  },
};
</script>
